import React from 'react';
import {
  Row,
  Col,
} from 'react-bootstrap';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

import { formatMonthDay } from '../../../utils';
import { generateTimesheetKey } from '../utils';

import ApproveButtonEnhanced from './ApproveButtonEnhanced';
import AddGuaranteedTimeModal from './AddGuaranteedTimeModal';

import './TimesheetList.css';

const propTypes = exact({
  timesheets: PropTypes.array,
  selectedTimesheetKey: PropTypes.string,
  dispatchSelectTimesheetKey: PropTypes.func.isRequired,

  /* eslint-disable react/no-unused-prop-types */
  /* Query variable props */
  supervisorId: PropTypes.number.isRequired,
  approvalState: PropTypes.string.isRequired,
  /* eslint-enable react/no-unused-prop-types */
});

const TimesheetList = (props) => {
  const {
    timesheets, dispatchSelectTimesheetKey, selectedTimesheetKey,
  } = props;

  const timesheetRow = (timesheet) => {
    const {
      user,
      state,
      start_date,
      overtime,
      approvable,
      missing_timesheets: missingTimesheets,
      unworked_per_diems: unworkedPerDiems,
      pending_per_diems: pendingPerDiems,
    } = timesheet;
    const timesheetInfo = timesheet;
    const weeklyStartDate = formatMonthDay(start_date.iso8601);

    const isApproved = state && state === 'approved';

    const timesheetKey = generateTimesheetKey(timesheet);

    const handleSelect = () => {
      dispatchSelectTimesheetKey(timesheetKey, isApproved);
    };

    const isActive = selectedTimesheetKey && timesheetKey === selectedTimesheetKey;

    return (
      /* This ID is used for styling purposes. Check css file */
      <div
        id="listItemForStyling"
        key={timesheetKey}
        className={`list-group-item ${isActive ? 'active' : ''}`}
        onClick={() => { return handleSelect(); }}
      >
        <Row>
          <Col md={2} className="app-remove-side-padding">
            <ApproveButtonEnhanced
              forApproval={!isApproved}
              timesheet={timesheet}
              approvable={approvable}
              missingTimesheets={missingTimesheets}
              unworkedPerDiems={unworkedPerDiems}
              pendingPerDiems={pendingPerDiems}
            />
          </Col>

          <Col md={10} className="app-remove-side-padding timesheetList-text-block">
            <Row>
              <div>
                <h4 className="timesheetList-listitem-header">
                  {user.lastname}, {user.firstname}
                </h4> - {weeklyStartDate}
              </div>

            </Row>
            <Row>
              Hrs: {timesheetInfo.total_hours.to_string},
              OT: {overtime.to_string},
              PTO: {timesheetInfo.pto.to_string}
            </Row>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div>
      <div className="list-group">
        {timesheets.map(timesheetRow, this)}
      </div>
      <AddGuaranteedTimeModal />
    </div>
  );
};

TimesheetList.propTypes = propTypes;

export default TimesheetList;
